import { AlertSnackbar, type AlertSnackbarProps } from '../AlertSnackbar';
import { getErrorMessage } from './helpers';

export const ErrorSnackbar = ({
  error,
  ...props
}: Omit<AlertSnackbarProps, 'severity' | 'message'> & { error?: unknown }) => {
  return (
    <AlertSnackbar
      severity="error"
      message={error ? getErrorMessage(error) : ''}
      {...props}
    />
  );
};
